'use strict';

angular.module('imagetrend.components')
    .controller('hlpServiceTrainingReimbursementController', ['$scope', 'ServiceUserTrainings', 'TrainingUsers', 'Users', '$q', 'FBForms', function ($scope, ServiceUserTrainings, TrainingUsers, Users, $q, FBForms) {

        $scope.service_users = [];
        $scope.userTrainingUsed = {};
        $scope.serviceUserTrainings = {};
        $scope.loading = true;
        $scope.setUpAnswers = function () {
            // Add empty first row
            $scope.component.elementAnswer.push({
                service_id: $scope.parameters.service_id,
                license_request_id: $scope.parameters.license_request_id
            });

            $scope.service_users.forEach(function (user) {
                $scope.userTrainingUsed[user.id] = [];
                if ($scope.serviceUserTrainings[user.id] && $scope.serviceUserTrainings[user.id].length > 0) {
                    if (!$scope.pdf) {
                        TrainingUsers.getTrainingsForReimbursement({ user_id: user.id, license_request_id: $scope.parameters.license_request_id }).then(function (trainings) {
                            trainings.forEach(function (training) {
                                var answer = {
                                    service_id: $scope.parameters.service_id,
                                    user_id: user.id,
                                    first_name: user.first_name,
                                    last_name: user.last_name,
                                    nameandnumber: user.nameandnumber,
                                    license_request_id: $scope.parameters.license_request_id,
                                    reimburse: true,
                                    training_id: training.training_id,
                                    course_name: training.nameandnumber,
                                    trainings: trainings
                                };

                                // Get Answer
                                var reimbursement = $scope.serviceUserTrainings[user.id].find(function (element) {
                                    return element.training_id === training.training_id;
                                });
                                if (reimbursement) {
                                    answer.training = training;
                                    answer.user = user;

                                    answer.reimburse_date = reimbursement.reimburse_date;
                                    answer.reimburse_amount = reimbursement.reimburse_amount;
                                    if (reimbursement.training_user != null) {
                                        answer.training_completed_on = reimbursement.training_user.completed_on;
                                        answer.training_pass_fail = reimbursement.training_user.training_attendee_status_name;
                                    }

                                    $scope.userTrainingUsed[user.id].push(answer.training.training_id);
                                    // add answer infront of empty row for new adds
                                    $scope.component.elementAnswer.splice($scope.component.elementAnswer.length - 1, 0, answer);
                                }
                            });

                            // Remove the trainings from the answers on form
                            $scope.component.elementAnswer.forEach(function (answer) {
                                if ($scope.userTrainingUsed[answer.user_id]) {
                                    answer.trainings = answer.trainings.filter(function (training) {
                                        return $scope.userTrainingUsed[answer.user_id].indexOf(training.training_id) === -1 || training.training_id === answer.training_id;
                                    });
                                }
                            });
                        });
                    }
                }
            });
            $scope.loading = false;
        }

        if ($scope.pdf && $scope.component.elementAnswer.length > 0) {
            $scope.loading = false;
        }
        else {
            $scope.component.elementAnswer = [];
            var promises = [];

            if ($scope.parameters != null && $scope.parameters.service_id != null && $scope.parameters.license_request_id != null) {
                promises.push(FBForms.getReimbursementRules($scope.component.form_id).then(function (reimbursement_rules) {

                    return Users.getServiceUsersForReimbursement($scope.parameters.service_id).then(function (serviceUsers) {
                        // Only get users where their issue date & service start date meets the rules specified in the form-builder-component
                        $scope.service_users = serviceUsers.filter(function (user) {
                            var certTimezoneOffset = (user.primary_cert_initial_issue_date) ? user.primary_cert_initial_issue_date.getTimezoneOffset() * 60000 : null; // getTimezoneOffset() returns in minutes
                            var serviceTimezoneOffset = (user.service_user_start_date) ? user.service_user_start_date.getTimezoneOffset() * 60000 : null;
                            var ruleTime = calculateReimbursementRuleTime(reimbursement_rules, certTimezoneOffset, serviceTimezoneOffset);

                            var certLengthPass = (ruleTime.certification_rule_time === null || user.primary_cert_initial_issue_date === null) ? true : user.primary_cert_initial_issue_date <= ruleTime.certification_rule_time;
                            var serviceLengthPass = (ruleTime.service_rule_time === null || user.service_user_start_date === null) ? true : user.service_user_start_date <= ruleTime.service_rule_time;

                            return certLengthPass && serviceLengthPass;
                        });
                    });
                }));
                promises.push(ServiceUserTrainings.get({ license_request_id: $scope.parameters.license_request_id }).then(function (serviceUserTrainings) {
                    if (serviceUserTrainings != null) {
                        serviceUserTrainings.forEach(function (sut) {
                            if (sut.service_id == $scope.parameters.service_id && sut.user_id != null) {
                                if (!$scope.serviceUserTrainings[sut.user_id]) $scope.serviceUserTrainings[sut.user_id] = []
                                $scope.serviceUserTrainings[sut.user_id].push(sut);
                            }
                        });
                    }
                }));
            }

            $q.all(promises).then(function() {
                $scope.setUpAnswers();
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });
        }

        $scope.trainingSelected = function (answer, oldAnswer, index) {
            if (answer.training == null) {
                removeTraingingFromDict(answer, oldAnswer, index); // remove training from the 'used' training list
                answer.training_id = null;
                answer.training_completed_on = null;
                answer.training_pass_fail = null;
                answer.reimburse_date = null;
                answer.reimburse_amount = null;
                answer.course_name = null;
            }
            else {
                answer.training_id = answer.training.training_id;
                answer.training_completed_on = answer.training.completed_on;
                answer.training_pass_fail = answer.training.training_attendee_status_name;
                answer.course_name = answer.training.nameandnumber;
                if (answer.reimburse_date == null) {
                    answer.reimburse_date = new Date();
                    answer.refresh = true;
                }
                addTraingingToDict(answer, oldAnswer, index);
            }
        };

        $scope.userSelected = function (answer, oldAnswer, index) {
            // Delete User
            if (answer.user == null) {
                removeTraingingFromDict(answer, oldAnswer, index);
                answer.user_id = null;
                answer.reimburse = false;
                answer.training = null;
                answer.training_id = null;
                answer.training_completed_on = null;
                answer.training_pass_fail = null;
                answer.reimburse_date = null;
                answer.reimburse_amount = null;
                answer.course_name = null;
                $scope.component.elementAnswer.splice(index, 1);
            }
            // Add user
            else {
                // User was updated & we need to update the dictionary of used Courses
                if (answer.user_id !== answer.user.id) { removeTraingingFromDict(answer, oldAnswer, index); }
                answer.reimburse = true;
                answer.user_id = answer.user.id;
                answer.name_and_number = answer.user.name_and_number;

                // Ensure Values are null (especially for user switch)
                answer.training = null;
                answer.training_id = null;
                answer.training_completed_on = null;
                answer.training_pass_fail = null;
                answer.reimburse_date = null;
                answer.reimburse_amount = null;
                answer.course_name = null;

                TrainingUsers.getTrainingsForReimbursement({ user_id: answer.user_id, license_request_id: $scope.parameters.license_request_id }).then(function (trainings) {
                    answer.trainings = trainings.filter(function (training) {
                        return !$scope.userTrainingUsed[answer.user_id].includes(training.training_id);
                    });
                });

                // Add subsequent row
                if ($scope.component.elementAnswer[$scope.component.elementAnswer.length - 1].user_id) {
                    $scope.component.elementAnswer.push({
                        service_id: $scope.parameters.service_id,
                        license_request_id: $scope.parameters.license_request_id
                    });
                }
            }
        };

        $scope.calculateTotalReimbursementAmount = function () {
            var reimbursementAmount = 0;
            $scope.component.elementAnswer.forEach(function (answer) {
                if (answer.reimburse_amount != null) {
                    reimbursementAmount += answer.reimburse_amount;
                }
            });
            return reimbursementAmount;
        }

        // Used to remove a Course from the Dictionary
        function removeTraingingFromDict(answer, oldAnswer, index) {
            const userId = (oldAnswer && oldAnswer.user_id) ? oldAnswer.user_id : answer.user_id;

            if (oldAnswer && oldAnswer.training_id !== null) {
                const usedTrainingIndex = $scope.userTrainingUsed[userId].indexOf(oldAnswer.training_id);
                $scope.userTrainingUsed[userId].splice(usedTrainingIndex, 1);

                var iter = 0;
                // To ensure this loop needs to be ran to sort other reimbursements for a matching user (>2 since 1 row is always empty)
                if ($scope.component.elementAnswer.length > 2) {
                    $scope.component.elementAnswer.forEach(function (element) {
                        // Don't edit the reminbursement we have edited
                        if (element.user_id === userId && iter !== index) {
                            element.trainings.push(oldAnswer);

                            // order list
                            element.trainings.sort(function (a, b) {
                                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                                return 0;
                            });
                        }
                        iter++;
                    });
                }
            }
        }

        // Used to add a Course to the Dictionary to keep track of used Courses
        function addTraingingToDict(answer, oldAnswer, index) {
            const userId = answer.user_id;
            const trainingId = answer.training.training_id;
            $scope.userTrainingUsed[userId].push(trainingId);

            var iter = 0;
            $scope.component.elementAnswer.forEach(function (element) {
                // Don't edit the reminbursement we have edited
                if (element.user_id === userId && iter !== index) {
                    // Find Course to remove from training lists
                    var removeIndex = -1;
                    for (var i = 0; i < element.trainings.length; i++) {
                        if (element.trainings[i].training_id === trainingId) {
                            removeIndex = i;
                            break;
                        }
                    }
                    if(removeIndex !== -1) element.trainings.splice(removeIndex, 1);

                    // If course selection was switched from one to another, add course back to training lists
                    if (oldAnswer && !element.trainings.includes(oldAnswer)) {
                        element.trainings.push(oldAnswer);
                        element.trainings.sort(function (a, b) {
                            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                            return 0;
                        });
                    }
                }
                iter++;
            });
        }

        // Calculates Dates for Primary Certification Issue Date & Service User Created On Reimbursement Rules.
        // Using user's timezone offset so times can match when dates are compared (user's dates are timezone adjusted from server-side).
        function calculateReimbursementRuleTime(reimbursement_rules, certOffset, serviceOffset) {
            var certRuleTime = new Date();
            var serviceRuleTime = new Date();
            var timezoneOffset = (certOffset !== null) ? certOffset : certRuleTime.getTimezoneOffset() * 60000;
            // User Primary Cert
            certRuleTime.setHours(0, 0, 0, 0);
            certRuleTime = setRuleDate(certRuleTime, reimbursement_rules.reimbursement_certification_length, reimbursement_rules.reimbursement_certification_length_type);
            certRuleTime = (certRuleTime !== null) ? new Date(certRuleTime.getTime() - timezoneOffset) : null;

            // Service Primary Cert
            timezoneOffset = (serviceOffset !== null) ? serviceOffset : serviceRuleTime.getTimezoneOffset() * 60000;
            serviceRuleTime.setHours(0, 0, 0, 0);
            serviceRuleTime = setRuleDate(serviceRuleTime, reimbursement_rules.reimbursement_service_length, reimbursement_rules.reimbursement_service_length_type);
            serviceRuleTime = (serviceRuleTime !== null) ? new Date(serviceRuleTime.getTime() - timezoneOffset) : null;

            return { certification_rule_time: certRuleTime, service_rule_time: serviceRuleTime };
        }

        // Sets the date based on the rules
        function setRuleDate(ruleTime, length, type) {
            if (length === null) { length = 0; }
            switch (type) {
                case 'Day':
                    ruleTime.setDate(ruleTime.getDate() - length);
                    return ruleTime;
                case 'Week':
                    ruleTime.setDate(ruleTime.getDate() - (length * 7));
                    return ruleTime;
                case 'Month':
                    ruleTime.setMonth(ruleTime.getMonth() - length);
                    return ruleTime;
                case 'Year':
                    ruleTime.setFullYear(ruleTime.getFullYear() - length);
                    return ruleTime;
                default:
                    return null;
            }
        }
    }])
    .directive('hlpServiceTrainingReimbursement', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/service-training-reimbursement/service-training-reimbursement.html',
            replace: true,
            controller: 'hlpServiceTrainingReimbursementController',
            scope: {
                parameters: '=?',
                component: '=?',
                pdf: '=?',
                completed: '@'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;